export const overflowWellKeytip = "yCa";
export const bottomBarOverflowMenuLabel = "zCa";
export const commandRibbonLabel = "ACa";
export const tabsContainerLabel = "BCa";
export const tabsContainerOverflowLabel = "CCa";
export const peripheralControlsGroupLabel = "DCa";
export const calloutCloseLabel = "ECa";
export const taskPaneOverflowMenuLabel = "FCa";
export const ribbonModeChevronLabel = "GCa";
export const ribbonModeChevronKeytip = "HCa";
export const taskPaneTabsContainerLabel = "ICa";
export const taskPaneRoleDescription = "JCa";
export const taskPaneOpeningString = "KCa";
export const rightRibbonPaddleLabel = "LCa";
export const leftRibbonPaddleLabel = "MCa";
export const search = "NCa";
export const ribbonSearchLabel = "OCa";
export const searchableMenuRegionLabel = "PCa";
export const clearSearch = "QCa";
export default {overflowWellKeytip,bottomBarOverflowMenuLabel,commandRibbonLabel,tabsContainerLabel,tabsContainerOverflowLabel,peripheralControlsGroupLabel,calloutCloseLabel,taskPaneOverflowMenuLabel,ribbonModeChevronLabel,ribbonModeChevronKeytip,taskPaneTabsContainerLabel,taskPaneRoleDescription,taskPaneOpeningString,rightRibbonPaddleLabel,leftRibbonPaddleLabel,search,ribbonSearchLabel,searchableMenuRegionLabel,clearSearch};